import React from 'react';
import { Gift } from 'lucide-react';
interface BonusCardProps {
  image: string;
  title: string;
  description: string;
  number: number;
}
export function BonusCard({
  image,
  title,
  description,
  number
}: BonusCardProps) {
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div onClick={scrollToPurchase} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer group border border-purple-100 flex flex-col h-full" data-id="element-146">
      <div className="relative h-64 overflow-hidden bg-gray-50 flex items-center justify-center p-4" data-id="element-147">
        <img src={image} alt={title} className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500" data-id="element-148" />
        <div className="absolute top-0 left-0 bg-orange-500 text-white text-xs font-bold px-3 py-1 rounded-br-lg uppercase tracking-wider" data-id="element-149">
          Regalo #{number}
        </div>
      </div>
      <div className="p-6 flex flex-col flex-grow" data-id="element-150">
        <div className="flex items-start gap-2 mb-3" data-id="element-151">
          <Gift className="w-5 h-5 text-purple-600 flex-shrink-0 mt-1" data-id="element-152" />
          <h3 className="text-lg font-bold text-gray-900 leading-tight group-hover:text-purple-700 transition-colors" data-id="element-153">
            {title}
          </h3>
        </div>
        <p className="text-gray-600 text-sm leading-relaxed flex-grow" data-id="element-154">
          {description}
        </p>
        <div className="mt-4 pt-4 border-t border-gray-100 text-center" data-id="element-155">
          <span className="text-sm font-semibold text-teal-600 group-hover:underline" data-id="element-156">
            ¡GRATIS HOY!
          </span>
        </div>
      </div>
    </div>;
}